export { default as AddC } from './components/add';
export { default as MainC } from './components/main';



// WEBPACK FOOTER //
// src/modules/roles/component.js